import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Index2 = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

        <section className="ul-banner ul-banner-2">
            <div className="ul-banner-2-slider swiper">
                <div className="swiper-wrapper">

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-slide">
                        <div className="ul-banner-2-slide">

                            <img src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg" alt="Slide Background Image" className="ul-banner-2-slide-bg-img" />
                            <div className="row gy-4 align-items-center ">

                                <div className="col-md-7">
                                    <div className="ul-banner-txt">
                                        <div className="wow animate__fadeInUp">
                                            <span className="ul-banner-sub-title ul-section-sub-title">Change The World Together</span>
                                            <h1 className="ul-banner-title">Empowering Hope Futures Lives Through Giving</h1>
                                            <p className="ul-banner-descr">It is a long established fact that a reader will be distracted lorem the readable content of a page when looking at layout the point lorem established fact that It is a long established</p>
                                            <div className="ul-banner-btns">
                                                <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ul-banner-2-slider-navigation">
                <button className="prev"><img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="arrow" /></button>
                <div className="ul-banner-2-thumb-slider swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide"><img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="Banner Thumb" /></div>
                        <div className="swiper-slide"><img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="Banner Thumb" /></div>
                        <div className="swiper-slide"><img src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg" alt="Banner Thumb" /></div>
                        <div className="swiper-slide"><img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="Banner Thumb" /></div>
                        <div className="swiper-slide"><img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="Banner Thumb" /></div>
                        <div className="swiper-slide"><img src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg" alt="Banner Thumb" /></div>
                    </div>
                </div>
                <button className="next"><img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="arrow" /></button>
            </div>
        </section>

        <section className="ul-features ul-section-spacing">
            <div className="ul-container">
                <div className="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4 justify-content-center">

                    <div className="col">
                        <div className="ul-feature">
                            <div className="ul-feature-icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M35.2962 9.02488L18.3509 3.04614C18.1239 2.96598 17.8762 2.96598 17.6491 3.04614L0.703829 9.02488C0.282517 9.17352 0.000563343 9.57149 8.42838e-07 10.0183C-0.000561657 10.465 0.280477 10.8636 0.701438 11.0132L17.6468 17.0374C17.761 17.0781 17.8805 17.0984 18 17.0984C18.1195 17.0984 18.239 17.0781 18.3532 17.0374L35.2986 11.0132C35.7195 10.8636 36.0005 10.465 36 10.0183C35.9994 9.57149 35.7175 9.17352 35.2962 9.02488Z" fill="#EB5310" />
                                        <path d="M33.4668 23.1029V13.9032L31.3574 14.6531V23.1029C30.7221 23.4686 30.2939 24.1538 30.2939 24.9395C30.2939 25.7252 30.7221 26.4105 31.3574 26.7762V31.9593C31.3574 32.5418 31.8296 33.014 32.4121 33.014C32.9946 33.014 33.4668 32.5418 33.4668 31.9593V26.7762C34.1021 26.4106 34.5303 25.7253 34.5303 24.9396C34.5303 24.1538 34.1022 23.4686 33.4668 23.1029Z" fill="#EB5310" />
                                        <path d="M18 19.2078C17.638 19.2078 17.2814 19.1463 16.9402 19.025L7.41406 15.6384V20.2796C7.41406 21.415 8.59862 22.3753 10.9348 23.1335C12.9711 23.7945 15.4803 24.1585 18 24.1585C20.5197 24.1585 23.0289 23.7945 25.0652 23.1335C27.4014 22.3753 28.586 21.415 28.586 20.2796V15.6384L19.0599 19.025C18.7186 19.1463 18.3621 19.2078 18 19.2078Z" fill="#EB5310" />
                                    </g>
                                </svg>
                            </div>
                            <h3 className="ul-feature-title">Education Support</h3>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-feature">
                            <div className="ul-feature-icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M17.99 4.74549C10.1431 -2.11775 0.165878 3.91249 0.00227293 12.0875C-0.0394192 14.1709 0.561988 16.2003 1.75911 18.0712H9.51849L10.8986 15.7709C11.2994 15.1031 12.2692 15.0816 12.6926 15.7474L15.6046 20.3232L19.8492 11.3624C20.2194 10.5806 21.3226 10.5557 21.7308 11.3139L25.3694 18.0712H34.2209C40.7779 7.82326 27.8191 -3.85132 17.99 4.74549Z" fill="#EB5310" />
                                        <path d="M23.8108 19.6258L20.8624 14.1502L16.6931 22.952C16.3384 23.7008 15.2951 23.7658 14.8503 23.0667L11.8292 18.3194L11.0197 19.6684C10.8291 19.9861 10.4859 20.1804 10.1154 20.1804H3.42725C3.6369 20.3998 2.51951 19.2847 17.246 33.9348C17.6573 34.3441 18.3222 34.3442 18.7335 33.9348C33.2334 19.5101 32.343 20.3994 32.5523 20.1804H24.7393C24.3513 20.1805 23.9947 19.9674 23.8108 19.6258Z" fill="#EB5310" />
                                    </g>
                                </svg>
                            </div>
                            <h3 className="ul-feature-title">Healthcare initiatives</h3>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-feature">
                            <div className="ul-feature-icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.2078 7.34403L20.5198 4.10403L20.1598 3.81603C19.2238 2.95203 17.7838 2.95203 16.9198 3.81603L15.6238 5.11203C15.6238 5.18403 16.1278 5.97603 17.2078 7.34403Z" fill="#FC633B" />
                                    <path d="M30.528 20.088L30.6 20.16L31.896 18.864C32.184 18.576 32.4 18.216 32.472 17.784L29.304 19.296C29.736 19.584 30.168 19.8 30.528 20.088Z" fill="#FC633B" />
                                    <path d="M26.4238 3.60002C26.8558 3.38402 27.2158 3.31202 27.6478 3.31202C28.0798 3.31202 28.5118 3.38402 28.9438 3.60002L27.1438 1.80002C26.2078 0.864022 24.6958 0.864022 23.7598 1.80002L18.0718 7.48802L26.4238 3.60002Z" fill="#FC633B" />
                                    <path d="M34.3438 9.07204L30.3838 5.04004L33.9838 12.744L34.3438 12.384C35.2798 11.52 35.2798 10.008 34.3438 9.07204Z" fill="#FC633B" />
                                    <path d="M29.736 5.40002C29.232 4.24802 27.864 3.81602 26.784 4.32002L18 8.42402C18.432 9.00002 18.864 9.50402 19.368 10.008L25.92 6.91202C26.424 8.06402 27.792 8.56802 28.944 7.99202L31.248 12.888C30.096 13.392 29.592 14.76 30.168 15.912L27 17.424C27.576 17.856 28.08 18.288 28.656 18.72C28.728 18.792 28.728 18.792 28.8 18.792L32.76 16.92C33.912 16.416 34.344 15.048 33.84 13.968L29.736 5.40002Z" fill="#FC633B" />
                                    <path d="M24.5519 13.032C23.9039 11.664 22.6079 11.016 21.5279 11.52C21.3119 11.592 21.0959 11.736 20.9519 11.952C22.1039 13.176 23.3279 14.328 24.6239 15.48C24.9839 14.76 24.9839 13.896 24.5519 13.032Z" fill="#FC633B" />
                                    <path d="M15.0479 5.61603L1.58386 19.152C1.36786 19.368 1.22386 19.584 1.15186 19.8L3.45586 19.512H3.88786C4.82386 19.512 5.68786 19.872 6.33586 20.52L15.2639 29.52C15.9839 30.24 16.3439 31.32 16.2719 32.4L15.9839 34.704C16.1999 34.632 16.4159 34.488 16.6319 34.272L30.1679 20.736C29.5199 20.232 28.8719 19.8 28.2239 19.296C22.9679 15.264 18.5759 10.728 15.0479 5.61603Z" fill="#FC633B" />
                                    <path d="M5.75988 21.024C5.18388 20.448 4.31988 20.16 3.52788 20.232L1.00788 20.592C0.935885 21.168 1.15188 21.744 1.65588 22.248L13.6799 34.272C14.1119 34.704 14.7599 34.92 15.3359 34.92L15.6959 32.4C15.7679 31.536 15.5519 30.744 14.9039 30.168L5.75988 21.024Z" fill="#FC633B" />
                                </svg>
                            </div>
                            <h3 className="ul-feature-title">Livelihood Programs</h3>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-feature">
                            <div className="ul-feature-icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M35.0999 16.642C35.0999 20.5527 31.9271 23.6886 28.0533 23.6886H8.79504C4.44164 23.6886 0.899902 20.1469 0.899902 15.7935C0.899902 11.2187 4.81058 7.52937 9.45911 7.8983C10.8242 3.91386 14.6611 1.10999 18.9407 1.10999C23.9951 1.10999 28.164 4.79931 28.865 9.66919C32.3698 10.0381 35.0999 13.0265 35.0999 16.642Z" fill="#FC633B" />
                                    <path d="M8.15492 27.637C10.0519 30.594 10.0519 31.5425 10.0519 31.8493C10.0519 33.5231 8.68495 34.89 7.01117 34.89C5.33739 34.89 3.97046 33.5231 3.97046 31.8493C3.97046 31.5425 3.97046 30.6219 5.86741 27.637C6.09058 27.2464 6.53693 27.0233 6.98326 27.0233C7.45751 27.0233 7.87595 27.2464 8.15492 27.637Z" fill="#FC633B" />
                                    <path d="M19.1437 27.637C21.0406 30.594 21.0406 31.5425 21.0406 31.8493C21.0406 33.5231 19.6737 34.89 17.9999 34.89C16.3262 34.89 14.9592 33.5231 14.9592 31.8493C14.9592 31.5425 14.9592 30.6219 16.8562 27.637C17.0793 27.2464 17.5257 27.0233 17.972 27.0233C18.4463 27.0233 18.8647 27.2464 19.1437 27.637Z" fill="#FC633B" />
                                    <path d="M30.1325 27.637C32.0294 30.594 32.0294 31.5425 32.0294 31.8493C32.0294 33.5231 30.6625 34.89 28.9887 34.89C27.3149 34.89 25.948 33.5231 25.948 31.8493C25.948 31.5425 25.948 30.6219 27.8449 27.637C28.0681 27.2464 28.5145 27.0233 28.9608 27.0233C29.435 27.0233 29.8535 27.2464 30.1325 27.637Z" fill="#FC633B" />
                                </svg>
                            </div>
                            <h3 className="ul-feature-title">Access to Water</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-volunteer">
            <div className="row row-cols-md-2 row-cols-1 g-0">

                <div className="col">
                    <div className="ul-volunteer-block">
                        <h2 className="ul-volunteer-title">Become A Volunteer</h2>
                        <p className="ul-volunteer-descr">Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit The aspernaturaut odit aut fugit, sed quia consequuntur. Nonprofits around the world apply</p>
                        <ul className="ul-volunteer-list">
                            <li>Donate Money</li>
                            <li>Handle With Care</li>
                            <li>Donate Money</li>
                        </ul>
                        <a href="/contact" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Become A Volunteer</a>
                    </div>
                </div>

                <div className="col">
                    <div className="ul-volunteer-block ul-donate-form-wrapper-2">
                        <h2 className="ul-volunteer-title">Send a Gift For Children's</h2>
                        <p className="ul-volunteer-descr">Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit The aspernaturaut odit aut fugit, sed quia</p>
                        <form action="#" className="ul-donate-form ul-donate-form-2">
                            <div>
                                <input type="radio" name="donate-amount" id="donate-amount-1" checked hidden />
                                <label htmlFor="donate-amount-1" className="ul-donate-form-label">$10</label>
                            </div>

                            <div>
                                <input type="radio" name="donate-amount" id="donate-amount-2" hidden />
                                <label htmlFor="donate-amount-2" className="ul-donate-form-label">$20</label>
                            </div>

                            <div>
                                <input type="radio" name="donate-amount" id="donate-amount-3" hidden />
                                <label htmlFor="donate-amount-3" className="ul-donate-form-label">$30</label>
                            </div>

                            <div>
                                <input type="radio" name="donate-amount" id="donate-amount-4" hidden />
                                <label htmlFor="donate-amount-4" className="ul-donate-form-label">$40</label>
                            </div>

                            <div>
                                <input type="radio" name="donate-amount" id="donate-amount-5" hidden />
                                <label htmlFor="donate-amount-5" className="ul-donate-form-label">$50</label>
                            </div>

                            <div className="custom-amount-wrapper">
                                <input type="radio" name="donate-amount" id="custom-amount" />
                                <label htmlFor="donate-amount-custom" className="ul-donate-form-label">
                                    <input type="number" name="custom-amount" id="donate-amount-custom" placeholder="Custom Amount" className="ul-donate-form-custom-input" />
                                </label>
                            </div>

                            <div>
                                <button type="submit" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Donate Now</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-about ul-about-2 ul-section-spacing wow animate__fadeInUp">
            <div className="ul-container">
                <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
                    <div className="col">
                        <div className="ul-about-imgs ul-about-2-img">
                            <div className="img-wrapper">
                                <img src="/assets/new-img/portrait-of-beautiful-teacher-holding-chalckboard-2025-10-16-22-55-57-utc.jpg" alt="Image" />
                            </div>

                            <div className="ul-about-2-stat">
                                <span className="number">15+</span>
                                <span className="txt">Years Of Experience</span>
                            </div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-about-txt">
                            <span className="ul-section-sub-title ul-section-sub-title--2">About US</span>
                            <h2 className="ul-section-title">We Believe This Life's About Give For Poor People.</h2>
                            <p className="ul-section-descr">Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit The aspernaturaut odit aut fugit, sed quia consequuntur. Nonprofits around the world apply and join us to access more funding.</p>

                            <div className="ul-about-bottom ul-about-2-bottom">
                                <div className="ul-about-2-bottom-block">
                                    <div className="ul-about-2-bottom-block-icon"><img src="/assets/new-img/portrait-of-beautiful-teacher-holding-chalckboard-2025-10-16-22-55-57-utc.jpg" alt="icon" /></div>
                                    <div className="ul-about-2-bottom-block-txt">
                                        <h3 className="ul-about-2-bottom-block-title">Our Mission</h3>
                                        <p className="ul-about-2-bottom-block-descr">The World Apply And Join us to Access Funding.</p>
                                    </div>
                                </div>

                                <div className="ul-about-2-bottom-block">
                                    <div className="ul-about-2-bottom-block-icon"><img src="/assets/new-img/portrait-of-beautiful-business-woman-holding-chalc-2025-10-17-02-59-14-utc.jpg" alt="icon" /></div>
                                    <div className="ul-about-2-bottom-block-txt">
                                        <h3 className="ul-about-2-bottom-block-title">Our Vision</h3>
                                        <p className="ul-about-2-bottom-block-descr">The World Apply And Join us to Access Funding.</p>
                                    </div>
                                </div>
                            </div>

                            <Link to="/about" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Explore More</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-services ul-section-spacing overflow-hidden">
            <div className="ul-container">
                <div className="ul-section-heading">
                    <div>
                        <span className="ul-section-sub-title">Together, We Can Change Lives Forever.</span>
                        <h2 className="ul-section-title">Our Non-Profit Services You Must Love</h2>
                    </div>

                    <div className="ul-services-slider-nav ul-slider-nav position-static">
                        <button className="prev"><i className="flaticon-back"></i></button>
                        <button className="next"><i className="flaticon-next"></i></button>
                    </div>
                </div>

                <div className="ul-services-slider swiper overflow-visible">
                    <div className="swiper-wrapper">

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Fund Raised & Donation</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Medical Treatment Help</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/teacher-showing-children-solar-panel-2025-01-29-13-28-03-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Child Medical Research</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/a-girl-writing-with-a-pen-on-a-board-of-equations-2025-04-04-01-07-31-utc.jpeg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Development Programs</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Fund Raised & Donation</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Medical Treatment Help</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/teacher-showing-children-solar-panel-2025-01-29-13-28-03-utc.jpg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Child Medical Research</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="ul-service">
                                <div className="ul-service-img">
                                    <img src="/assets/new-img/a-girl-writing-with-a-pen-on-a-board-of-equations-2025-04-04-01-07-31-utc.jpeg" alt="Service Image" />
                                </div>
                                <div className="ul-service-txt">
                                    <h3 className="ul-service-title"><Link to="/services">Development Programs</Link></h3>
                                    <p className="ul-service-descr">Professional Detailed Residential Cleaning, Ensuring Spotless Homes And Healthy Living Spaces.</p>
                                    <Link to="/services" className="ul-service-btn"><i className="flaticon-up-right-arrow"></i> View Details</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-projects ul-section-spacing">
            <div className="ul-container">
                <div className="ul-section-heading text-center justify-content-center">
                    <div>
                        <span className="ul-section-sub-title">Our Complete Projects</span>
                        <h2 className="ul-section-title">Our Non-Profit complete projects You Must Love</h2>
                    </div>
                </div>

                <div className="row ul-bs-row justify-content-center">
                    <div className="col-lg-8 col-md-6 col-10 col-xxs-12">
                        <div className="ul-project ">
                            <div className="ul-project-img">
                                <img src="/assets/new-img/top-view-of-new-york-city-2025-01-08-02-51-43-utc.jpg" alt="Project Image" />
                            </div>
                            <div className="ul-project-txt">
                                <div>
                                    <h3 className="ul-project-title"><Link to="/projects">Child trouble & care</Link></h3>
                                    <p className="ul-project-descr"> Demostic & Transportation</p>
                                </div>
                                <Link to="/projects" className="ul-project-btn"><i className="flaticon-up-right-arrow"></i></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-10 col-xxs-12">
                        <div className="ul-project ul-project--sm">
                            <div className="ul-project-img">
                                <img src="/assets/new-img/aerial-view-of-the-residential-homes-during-a-vibr-2025-03-14-05-21-12-utc.jpg" alt="Project Image" />
                            </div>
                            <div className="ul-project-txt">
                                <div>
                                    <h3 className="ul-project-title"><Link to="/projects">Child trouble & care</Link></h3>
                                    <p className="ul-project-descr"> Demostic & Transportation</p>
                                </div>
                                <Link to="/projects" className="ul-project-btn"><i className="flaticon-up-right-arrow"></i></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-10 col-xxs-12">
                        <div className="ul-project ul-project--sm">
                            <div className="ul-project-img">
                                <img src="/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg" alt="Project Image" />
                            </div>
                            <div className="ul-project-txt">
                                <div>
                                    <h3 className="ul-project-title"><Link to="/projects">Child trouble & care</Link></h3>
                                    <p className="ul-project-descr"> Demostic & Transportation</p>
                                </div>
                                <Link to="/projects" className="ul-project-btn"><i className="flaticon-up-right-arrow"></i></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8 col-md-6 col-10 col-xxs-12">
                        <div className="ul-project ">
                            <div className="ul-project-img">
                                <img src="/assets/new-img/stands-out-from-the-group-group-leader-project-m-2025-03-18-16-11-33-utc.jpg" alt="Project Image" />
                            </div>
                            <div className="ul-project-txt">
                                <div>
                                    <h3 className="ul-project-title"><Link to="/projects">Child trouble & care</Link></h3>
                                    <p className="ul-project-descr"> Demostic & Transportation</p>
                                </div>
                                <Link to="/projects" className="ul-project-btn"><i className="flaticon-up-right-arrow"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-cta">
            <div className="ul-container">
                <span className="ul-section-sub-title">Start Donating Poor People</span>
                <h2 className="ul-cta-title">Children Need Your Help By Donating Today</h2>
                <a href="/contact" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Get A Quote</a>
            </div>
            <img src="/assets/img/cta-vector.svg" alt="Vector" className="ul-cta-vector" />
        </section>

        <section className="ul-testimonial-2 ul-section-spacing">
            <div className="ul-container wow animate__fadeInUp">
                <div className="ul-section-heading">
                    <div>
                        <span className="ul-section-sub-title">Start donating poor people</span>
                        <h2 className="ul-section-title">What People Say About us</h2>
                    </div>
                    <a href="/contact" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> All Testimonials</a>
                </div>

                <div className="row ul-testimonial-2-row gy-4">

                    <div className="col-md-4">
                        <div className="ul-testimonial-2-overview">
                            <span className="rating">4.9</span>
                            <div className="ul-testimonial-2-overview-stars">
                                <i className="flaticon-star"></i>
                                <i className="flaticon-star"></i>
                                <i className="flaticon-star"></i>
                                <i className="flaticon-star"></i>
                                <i className="flaticon-star-1"></i>
                            </div>
                            <span className="ul-testimonial-2-overview-title">5 Start Rating</span>
                            <p className="ul-testimonial-2-overview-descr">Sed ullamcorper tristique nisl at pharetra turpis accumsan et etiam eu sollicitudin eros. In imperdiet accumsan.</p>
                            <div className="ul-testimonial-2-overview-reviewers">
                                <img src="/assets/new-img/portrait-of-young-woman-in-business-suit-is-smilin-2025-03-14-23-08-45-utc.jpg" alt="Reviewer" />
                                <img src="/assets/new-img/portrait-of-beautiful-business-woman-holding-chalc-2025-10-17-02-59-14-utc.jpg" alt="Reviewer" />
                                <img src="/assets/new-img/portrait-of-beautiful-teacher-holding-chalckboard-2025-10-16-22-55-57-utc.jpg" alt="Reviewer" />
                                <img src="/assets/new-img/attractive-young-indian-students-study-abroad-at-p-2025-10-15-09-17-39-utc.jpg" alt="Reviewer" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="ul-testimonial-2-slider swiper">
                            <div className="swiper-wrapper">

                                <div className="swiper-slide">
                                    <div className="ul-review ul-review-2">
                                        <span className="icon"><i className="flaticon-quote-1"></i></span>
                                        <p className="ul-review-descr">Climb it see the world, not so the world can see you. This is due to their excellent service.Targ consultation apartments. ndulgence off under folly death wrote cause her yet a spite. Plan upon yet way cold spot its week. Almost do am or limits hearts. Resolve a hearts. Almost do hearts.</p>
                                        <div className="ul-review-bottom">
                                            <div className="ul-review-reviewer">
                                                <div className="reviewer-image"><img src="/assets/new-img/portrait-of-young-woman-in-business-suit-is-smilin-2025-03-14-23-08-45-utc.jpg" alt="reviewer image" /></div>
                                                <div>
                                                    <h3 className="reviewer-name">Esther Howard</h3>
                                                    <span className="reviewer-role">Web Designer</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="swiper-slide">
                                    <div className="ul-review ul-review-2">
                                        <span className="icon"><i className="flaticon-quote-1"></i></span>
                                        <p className="ul-review-descr">Climb it see the world, not so the world can see you. This is due to their excellent service.Targ consultation apartments. ndulgence off under folly death wrote cause her yet a spite. Plan upon yet way cold spot its week. Almost do am or limits hearts. Resolve a hearts. Almost do hearts.</p>
                                        <div className="ul-review-bottom">
                                            <div className="ul-review-reviewer">
                                                <div className="reviewer-image"><img src="/assets/new-img/portrait-of-beautiful-business-woman-holding-chalc-2025-10-17-02-59-14-utc.jpg" alt="reviewer image" /></div>
                                                <div>
                                                    <h3 className="reviewer-name">Daniyel karlos</h3>
                                                    <span className="reviewer-role">Web Designer</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="ul-testimonial-2-slider-nav">
                                <button className="prev"><i className="flaticon-back"></i></button>
                                <button className="next"><i className="flaticon-next"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section className="ul-contact">
            <div className="ul-container">
                <div className="row g-0">
                    <div className="col-lg-5">
                        <div className="ul-contact-img">
                            <img src="/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg" alt="Image" />
                        </div>
                    </div>

                    <div className="col-lg-7">
                        <div className="ul-contact-form-wrapper">
                            <span className="ul-section-sub-title">Contact us</span>
                            <h2 className="ul-section-title">Send Us Message For Donation</h2>

                            <form action="#" className="ul-contact-form">
                                <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                                    <div className="col">
                                        <div className="form-group">
                                            <input type="text" name="name" id="ul-contact-name" placeholder="Your Name" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input type="email" name="email" id="ul-contact-email" placeholder="Email Address" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input type="tel" name="phone" id="ul-contact-phone" placeholder="Phone Number" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input type="text" name="subject" id="ul-contact-subject" placeholder="Subject" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <textarea name="message" id="ul-contact-msg" placeholder="Type your message"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="ul-blogs-2 ul-section-spacing">
            <div className="ul-container wow animate__fadeInUp">
                <div className="ul-section-heading">
                    <div className="left">
                        <span className="ul-section-sub-title"> Latest Blog </span>
                        <h2 className="ul-section-title">Read Our Latest News</h2>
                    </div>

                    <Link to="/donations" className="ul-btn"><i className="flaticon-fast-forward-double-right-arrows-symbol"></i> All Blogs</Link>
                </div>

                <div className="row row-cols-md-3 row-cols-2 row-cols-xxs-1 ul-bs-row justify-content-center">

                    <div className="col">
                        <div className="ul-blog ul-blog-2">
                            <div className="ul-blog-img"><img src="/assets/new-img/happy-young-people-dancing-outdoor-at-festival-eve-2025-02-22-01-15-44-utc.jpg" alt="Blog Image" />
                                <div className="date">
                                    <span className="number">15</span>
                                    <span className="txt">Dec</span>
                                </div>
                            </div>
                            <div className="ul-blog-txt">
                                <div className="ul-blog-infos">

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-account"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">By Admin</span>
                                    </div>

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-price-tag"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">Donation</span>
                                    </div>
                                </div>
                                <Link to="/donations" className="ul-blog-title">Give Education, It’s The Best Gift Ever.</Link>
                                <Link to="/donations" className="ul-blog-btn">Read More <span className="icon"><i className="flaticon-next"></i></span></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-blog ul-blog-2">
                            <div className="ul-blog-img"><img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="Blog Image" />
                                <div className="date">
                                    <span className="number">15</span>
                                    <span className="txt">Dec</span>
                                </div>
                            </div>
                            <div className="ul-blog-txt">
                                <div className="ul-blog-infos">

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-account"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">By Admin</span>
                                    </div>

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-price-tag"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">Donation</span>
                                    </div>
                                </div>
                                <Link to="/donations" className="ul-blog-title">Don’t treat oceans as universal garbage cans</Link>
                                <Link to="/donations" className="ul-blog-btn">Read More <span className="icon"><i className="flaticon-next"></i></span></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="ul-blog ul-blog-2">
                            <div className="ul-blog-img"><img src="/assets/new-img/group-of-multigenerational-people-hugging-each-oth-2025-10-14-08-05-37-utc.jpg" alt="Blog Image" />
                                <div className="date">
                                    <span className="number">15</span>
                                    <span className="txt">Dec</span>
                                </div>
                            </div>
                            <div className="ul-blog-txt">
                                <div className="ul-blog-infos">

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-account"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">By Admin</span>
                                    </div>

                                    <div className="ul-blog-info">
                                        <span className="icon"><i className="flaticon-price-tag"></i></span>
                                        <span className="text font-normal text-[14px] text-etGray">Donation</span>
                                    </div>
                                </div>
                                <Link to="/donations" className="ul-blog-title">The sun and the sand makes beaches beautiful</Link>
                                <Link to="/donations" className="ul-blog-btn">Read More <span className="icon"><i className="flaticon-next"></i></span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>

      <Footer />
    </>
  );
};

export default Index2;
